import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { rsvpEnsureTokenEndpoint } from '../../../endpoint/rsvp.ts'
import { fetchRsvpUpiti, deleteRsvpUpit, IRsvpUpit } from '../../../endpoint/index.ts'
import './index.css'

interface Props {
	plannerId: string;
}

// Link koji par dijeli s uzvanicima, i popis onih koje automatika nije mogla
// razriješiti (više osoba s istim imenom na popisu, pa je upit uručen paru).
const RsvpLinkPanel: React.FC<Props> = ({ plannerId }) => {
	const { t } = useTranslation('planner')
	const [link, setLink] = useState<string>('')
	const [upiti, setUpiti] = useState<IRsvpUpit[]>([])
	// Sklopljena po zadanom. Plan sale je ono zbog cega par otvara planer, pa
	// mu ovo ne smije stajati iznad glave kao pola ekrana.
	const [otvoren, setOtvoren] = useState(false)

	useEffect(() => {
		// Token se dohvaća jednom, na mount, i nikad ne osvježava: postojeći
		// token server nikad ne mijenja, pa već tiskana pozivnica ostaje
		// valjana. Zato efekt ovisi samo o plannerId, ne o samom linku.
		rsvpEnsureTokenEndpoint(plannerId)
			.then((token) => setLink(`${window.location.origin}/rsvp/${token}`))
			.catch(() => setLink(''))

		fetchRsvpUpiti(plannerId).then(setUpiti).catch(() => setUpiti([]))
	}, [plannerId])

	// Razriješen upit par miče sam - inače popis samo raste, jer ga ništa drugo
	// ne prazni. Redak nestaje tek kad brisanje uspije: nestao redak koji je i
	// dalje u bazi vratio bi se pri sljedećem otvaranju panela.
	const odbaci = async (upitId: string) => {
		try {
			await deleteRsvpUpit(plannerId, upitId)
			setUpiti((prev) => prev.filter((u) => u.id !== upitId))
		} catch {
			// Ostaje na popisu; par može pokušati ponovno.
		}
	}

	// Dok link nije stigao, ne prikazujemo ništa - polovično nacrtan panel s
	// praznim code blokom izgleda kao greška, a ne kao učitavanje.
	if (!link) return null

	return (
		<div className='rsvp-link-panel'>
			<button
				type='button'
				className='rsvp-traka'
				aria-expanded={otvoren}
				onClick={() => setOtvoren((v) => !v)}
			>
				<span className='rsvp-traka-strelica' aria-hidden='true'>
					{otvoren ? '▾' : '▸'}
				</span>
				<span>{t('rsvp.naslov')}</span>
				{/* Broj, ne recenica: "1 upit / 2 upita / 5 upita" trazi tri
				  * oblika u hrvatskom, srpskom, bosanskom i slovenskom. Znacka
				  * je usput i jedini nacin da par sazna da ga netko ceka dok je
				  * traka sklopljena. */}
				{upiti.length > 0 && (
					<span className='rsvp-traka-broj'>{upiti.length}</span>
				)}
			</button>

			{otvoren && (
				<div className='rsvp-sadrzaj'>
			<p className='rsvp-link-naslov'>{t('rsvp.linkNaslov')}</p>
			<div className='rsvp-link-row'>
				<code className='rsvp-link-code'>{link}</code>
				<button
					type='button'
					className='rsvp-copy-btn'
					onClick={() => navigator.clipboard.writeText(link)}
				>
					{t('rsvp.kopiraj')}
				</button>
			</div>

			{upiti.length > 0 && (
				<div className='rsvp-upiti'>
					<p className='rsvp-upiti-naslov'>{t('rsvp.upitiNaslov')}</p>
					<p className='rsvp-upiti-objasnjenje'>{t('rsvp.upitObjasnjenje')}</p>
					<ul className='rsvp-upiti-list'>
						{upiti.map((u) => (
							<li key={u.id} className='rsvp-upit-item'>
								<span className='rsvp-upit-ime'>{u.ime} {u.prezime}</span>
								<button
									type='button'
									className='rsvp-upit-odbaci'
									title={t('rsvp.odbaciUpit')}
									onClick={() => odbaci(u.id)}
								>
									{t('rsvp.odbaciUpit')}
								</button>
							</li>
						))}
					</ul>
				</div>
			)}
				</div>
			)}
		</div>
	)
}

export default RsvpLinkPanel
